import { render, staticRenderFns } from "./DepartList.vue?vue&type=template&id=23af374c&scoped=true&"
import script from "./DepartList.vue?vue&type=script&lang=js&"
export * from "./DepartList.vue?vue&type=script&lang=js&"
import style0 from "./DepartList.vue?vue&type=style&index=0&id=23af374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af374c",
  null
  
)

export default component.exports